import { render, staticRenderFns } from "./ElementUI.vue?vue&type=template&id=4d912f5c&"
import script from "./ElementUI.vue?vue&type=script&lang=js&"
export * from "./ElementUI.vue?vue&type=script&lang=js&"
import style0 from "./ElementUI.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports